import React, {PureComponent} from 'react';
import Select from 'react-select';
import './modal.css'

const options = [
    {value: 'chocolate', label: 'Chocolate'},
    {value: 'strawberry', label: 'Strawberry'},
    {value: 'vanilla', label: 'Vanilla'},
];
const customStyles1 = {
    option: (provided, state) => ({
        ...provided,
        padding: 1,
        height: 20
    }),
    control: (provided) => ({
        width: 100,
        height: 40,
        border: 2
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return {...provided, opacity, transition};
    }
}
const colourStyles = {
    control: styles => ({...styles, backgroundColor: 'white', maxHeight: '10px'}),
    valueContainer: styles => ({...styles, backgroundColor: 'white', maxHeight: '10px'}),
};
const customStyles = {
    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
            color: '#ffffff',
        }
    },
    control: (provided, state) => ({
        ...provided,
        background: '#fff',
        minHeight: '25px',
        height: '26px',
        width: '150px',
        boxShadow: state.isFocused ? 'inset 0px 1px 3px rgba(0,0,0,0.075), 0px 0px 8px 0px rgba(102,175,233,0.60)' : null,
        outline: 0,
        fontSize: "14px",
        fontFamily: 'Raleway, Arial',
        borderColor: state.isFocused ? "#66AFE9" : provided.borderColor,
        '&:hover': {
            borderColor: state.isFocused ? '#66AFE9 !important' : provided.borderColor,
        },
    }),
    option: (provided, state) => ({
        ...provided,
        background: state.isSelected ? '#F2F6F7' : null,
        color: 'black',
        minHeight: '25px',
        height: '25px',
        width: '150px',
        fontSize: "14px",
        fontFamily: 'Raleway, Arial',
    }),
    menu: (provided, state) => ({
        ...provided,
        width: '150px',
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: '25px',
        padding: '0 6px',
    }),
    input: () => ({
        fontFamily: 'Raleway, Arial',
        '& input': {
            font: 'inherit'
        },
        '& input:focus': {
            boxShadow: 'none !important',
        },
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '26px',
    }),
};

class EditableSelect extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: this.props.comboValue,
            input: ''
        };
    }

    handleChange = (event) => {
        this.setState({value: event.target.value});
        console.log('event.target.value', event.target.value)
        this.props.onChange(event);
    };

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        // Update internal state when comboValue prop changes
        if (this.props.comboValue !== prevProps.comboValue) {
            this.setState({selectedOption: this.props.comboValue});
        }
    }

    handleChange = (selectedOption) => {
        if (selectedOption.label == 'None')
            selectedOption = {value: '', label: ''};
        this.setState({selectedOption});
        this.setState({value: selectedOption.value});
        this.props.onChange(selectedOption.value);
    };

    handleBlur() {
        let {inputValue} = this.selector;
        this.selector.createNewOption(inputValue)
    }

    render() {
        const {selectedOption} = this.state;
        return (
            <Select
                value={selectedOption}
                options={this.props.items}
                inputValue={this.state.input}
                onChange={this.handleChange}
                styles={customStyles}
                placeholder='Status'
                onInputChange={(value, action) => {
                    if (action.action === "input-change") {
                        this.setState({input: value});
                        this.setState({value: value});
                        this.props.onChange(value);
                    }
                }}
            />
        );
    }
}

export default EditableSelect;